import { AssignmentDate } from '../../AssignmentHelpers/AssignmentDate'
import { AssignmentPopover } from '../../AssignmentHelpers/AssignmentPopover'
import {
  ContentLiveDateDialogue,
  DueDateDialogue,
} from '../../AssignmentHelpers/AssignmentPopover/dialogues'
import { TaskProps } from '../types'

type TaskDueDateKeys = 'dueDate' | 'hardDueDate' | 'overdue' | 'contextLiveDate'

type TaskDueDateProps = Pick<TaskProps, TaskDueDateKeys>

export const TaskDueDate: React.FC<TaskDueDateProps> = ({
  contextLiveDate,
  dueDate,
  hardDueDate,
  overdue = false,
}) => {
  if (dueDate === undefined) return null

  const dialogue =
    hardDueDate && contextLiveDate !== undefined ? (
      <DueDateDialogue dueDate={dueDate} contentLiveDate={contextLiveDate} />
    ) : (
      <ContentLiveDateDialogue dueDate={dueDate} />
    )

  return (
    <AssignmentPopover
      triggerEvent="hover"
      trigger={
        <AssignmentDate
          dueAtDate={hardDueDate}
          dueDate={dueDate}
          overdue={overdue}
        />
      }
    >
      {dialogue}
    </AssignmentPopover>
  )
}
